var _ellipse, _path, _path2, _path3, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgConjugationdone = function SvgConjugationdone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 227,
    viewBox: "0 0 200 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.314,
    cy: 111.999,
    rx: 43.8577,
    ry: 44,
    fill: "#F7A491"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.973 111.999C161.973 145.053 135.263 171.849 102.317 171.849C69.3701 171.849 42.6607 145.053 42.6607 111.999C42.6607 78.9438 69.3701 52.1485 102.317 52.1485C135.263 52.1485 161.973 78.9438 161.973 111.999Z",
    stroke: "#F7A491",
    strokeOpacity: 0.6,
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.06 111.999C135.06 129.589 120.846 143.849 103.313 143.849C85.7808 143.849 71.567 129.589 71.567 111.999C71.567 94.4078 85.7808 80.1485 103.313 80.1485C120.846 80.1485 135.06 94.4078 135.06 111.999Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.895 111.999C185.895 157.756 148.922 194.849 103.314 194.849C57.7055 194.849 20.732 157.756 20.732 111.999C20.732 66.2413 57.7055 29.1485 103.314 29.1485C148.922 29.1485 185.895 66.2413 185.895 111.999Z",
    stroke: "#F7A491",
    strokeOpacity: 0.6,
    strokeWidth: 0.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.314,
    cy: 111.999,
    rx: 17.9418,
    ry: 18,
    fill: "#FFD3C9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.048,
    cy: 25.998,
    rx: 5.9806,
    ry: 6,
    fill: "#F7A491"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.103,
    cy: 61.9985,
    rx: 5.98059,
    ry: 6,
    fill: "#FCEA8F"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5724,
    cy: 203.999,
    rx: 5.98059,
    ry: 6,
    fill: "#F7A491"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.01,
    cy: 11.998,
    rx: 2.9903,
    ry: 3,
    fill: "#90CDCB"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.246,
    cy: 87.9985,
    rx: 1.99353,
    ry: 2,
    fill: "#F6C463"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.3621,
    cy: 169.999,
    rx: 2.9903,
    ry: 3,
    fill: "#F7A491"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.6146,
    cy: 213.999,
    rx: 2.9903,
    ry: 3,
    fill: "#FCEA8F"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.4559,
    cy: 112.999,
    rx: 2.9903,
    ry: 3,
    fill: "#FCEA8F"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5853,
    cy: 224.999,
    rx: 1.99353,
    ry: 2,
    fill: "#94D0CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.624 8.19547C180.272 7.77146 180.329 7.141 180.752 6.78729L185.346 2.94465C185.769 2.59094 186.397 2.64793 186.749 3.07194C187.102 3.49595 187.045 4.12641 186.622 4.48012L182.028 8.32276C181.605 8.67647 180.976 8.61948 180.624 8.19547Z",
    fill: "#F6C463"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M181.134 2.56156C181.557 2.20773 182.186 2.26474 182.538 2.6889L186.367 7.29691C186.72 7.72107 186.663 8.35175 186.24 8.70558C185.817 9.05941 185.188 9.00239 184.835 8.57824L181.006 3.97023C180.654 3.54607 180.711 2.91539 181.134 2.56156Z",
    fill: "#F6C463"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.575 60.7406C124.089 60.4799 123.905 59.8738 124.165 59.3868L126.982 54.0961C127.241 53.6091 127.845 53.4257 128.331 53.6864C128.818 53.9471 129.001 54.5532 128.742 55.0402L125.925 60.3309C125.666 60.8179 125.061 61.0013 124.575 60.7406Z",
    fill: "#90CDCB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.936 55.3272C123.195 54.8407 123.799 54.6574 124.285 54.9179L129.56 57.7474C130.046 58.0078 130.23 58.6133 129.971 59.0998C129.712 59.5863 129.108 59.7696 128.622 59.5091L123.346 56.6796C122.861 56.4192 122.677 55.8137 122.936 55.3272Z",
    fill: "#90CDCB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5861 27.3194C10.5608 27.6093 9.49643 27.0118 9.20863 25.985L6.08199 14.8293C5.79419 13.8024 6.39199 12.735 7.4172 12.4452C8.44242 12.1553 9.50682 12.7528 9.79462 13.7796L12.9213 24.9353C13.2091 25.9621 12.6113 27.0296 11.5861 27.3194Z",
    fill: "#FCEA8F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08587 21.9795C1.79844 20.9539 2.39547 19.8879 3.41937 19.5984L14.543 16.4535C15.5669 16.164 16.6299 16.7607 16.9174 17.7862C17.2048 18.8117 16.6078 19.8778 15.5839 20.1672L4.46025 23.3122C3.43634 23.6017 2.3733 23.005 2.08587 21.9795Z",
    fill: "#FCEA8F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M174.241 206.073C174.765 205.146 175.939 204.82 176.865 205.346L186.921 211.061C187.847 211.587 188.173 212.765 187.649 213.692C187.126 214.619 185.952 214.945 185.026 214.419L174.97 208.705C174.044 208.179 173.718 207.001 174.241 206.073Z",
    fill: "#F6C463"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M184.739 203.16C185.665 203.686 185.992 204.865 185.468 205.794L179.778 215.878C179.254 216.806 178.079 217.132 177.152 216.606C176.226 216.079 175.899 214.9 176.423 213.972L182.113 203.887C182.636 202.959 183.812 202.633 184.739 203.16Z",
    fill: "#F6C463"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9318 84.4586C17.2428 83.44 18.3193 82.8681 19.3363 83.1812L30.3847 86.583C31.4017 86.8962 31.9741 87.9757 31.6631 88.9943C31.3521 90.0129 30.2756 90.5848 29.2586 90.2716L18.2102 86.8698C17.1932 86.5567 16.6209 85.4771 16.9318 84.4586Z",
    fill: "#F7A491"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5522 79.3395C27.5705 79.6531 28.1436 80.734 27.8322 81.7539L24.4496 92.834C24.1382 93.8539 23.0603 94.4265 22.042 94.113C21.0237 93.7994 20.4507 92.7185 20.762 91.6986L24.1447 80.6185C24.456 79.5986 25.5339 79.026 26.5522 79.3395Z",
    fill: "#F7A491"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgConjugationdone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/conjugationdone.9c6a23ab2a563ca9dd96d9c3b5b1684d.blank.svg";